const { default: request } = require('src/utils/request')
import * as api from 'src/configs/API'

const getProfileHubs = (payload) => {
	return request.pmsApi({
		url: api.default.API_GET_CLIENT_HUBS,
		data: {
			ClientID: payload,
			// Status: 'Activated',
		},
		method: 'POST',
	})
}
const profileGetClientHubs = (payload) => {
	return request.pmsApi({
		url: api.default.API_GET_PROFILE_CLIENT_HUBS,
		data: {
			ClientID: payload,
			// Status: 'Activated',
		},
		method: 'POST',
	})
}
const getClientHubsFilterCombobox = (payload) => {
	return request.pmsApi({
		url: api.default.API_GET_CLIENT_HUBS_FILTER_COMBOBOX,
		data: {
			ClientID: payload,
			// Status: 'Activated',
		},
		method: 'POST',
	})
}

const getEnterPriseProfile = () => {
	return request.pmsApi({
		url: api.PMS_APIs.API_GET_CLIENT_ROOT_PROFILE,
		data: {},
		method: 'POST',
	})
}

const profileService = {
	getProfileHubs,
	getEnterPriseProfile,
	getClientHubsFilterCombobox,
	profileGetClientHubs,
}

export default profileService
